/**
 * Free download: every slide carries the watermark. PRO download: clean.
 */
export function resolveSlideWatermark(args: { isPro: boolean }): boolean {
  return !args.isPro;
}
